// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__kB1Uu","canvas":"style_canvas__kXntx","button":"style_button__Bc7dn"};